// extracted by mini-css-extract-plugin
export default {"rounded-checkbox":"RoundedCheckbox_rounded-checkbox__3E55X","circle":"RoundedCheckbox_circle__m3lNo","disabled":"RoundedCheckbox_disabled__7YMM2"};